import { supabase } from '../lib/supabase';

const toCamelCase = (obj) => {
  if (!obj) return obj;
  if (Array.isArray(obj)) return obj?.map(toCamelCase);
  if (typeof obj !== 'object') return obj;

  return Object.keys(obj)?.reduce((acc, key) => {
    const camelKey = key?.replace(/_([a-z])/g, (_, letter) => letter?.toUpperCase());
    acc[camelKey] = toCamelCase(obj?.[key]);
    return acc;
  }, {});
};

const toSnakeCase = (obj) => {
  if (!obj) return obj;
  if (Array.isArray(obj)) return obj?.map(toSnakeCase);
  if (typeof obj !== 'object') return obj;

  return Object.keys(obj)?.reduce((acc, key) => {
    const snakeKey = key?.replace(/[A-Z]/g, (letter) => `_${letter?.toLowerCase()}`);
    acc[snakeKey] = toSnakeCase(obj?.[key]);
    return acc;
  }, {});
};

export const skillService = {
  async getAllSkills() {
    const { data, error } = await supabase?.from('skills')?.select('*')?.order('display_order', { ascending: true });

    if (error) throw error;
    return toCamelCase(data);
  },

  async getSkillById(id) {
    const { data, error } = await supabase?.from('skills')?.select('*')?.eq('id', id)?.single();

    if (error) throw error;
    return toCamelCase(data);
  },

  async createSkill(skillData) {
    const { data: { user } } = await supabase?.auth?.getUser();
    if (!user) throw new Error('Not authenticated');

    const snakeData = toSnakeCase({
      ...skillData,
      createdBy: user?.id
    });

    const { data, error } = await supabase?.from('skills')?.insert(snakeData)?.select()?.single();

    if (error) throw error;
    return toCamelCase(data);
  },

  async updateSkill(id, skillData) {
    const snakeData = toSnakeCase(skillData);

    const { data, error } = await supabase?.from('skills')?.update(snakeData)?.eq('id', id)?.select()?.single();

    if (error) throw error;
    return toCamelCase(data);
  },

  async deleteSkill(id) {
    const { error } = await supabase?.from('skills')?.delete()?.eq('id', id);

    if (error) throw error;
  }
};
